import type { LegalPage } from '~/helpers/legal/legal-urls'
import { FileText } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { DropdownMenuItem } from '~/components/ui/dropdown-menu'
import { legalUrl } from '~/helpers/legal/legal-urls'

/**
 * Les documents légaux dans les menus utilisateur (#360), partagés par le menu du
 * back-office et celui de l'espace apprenant. Ils s'ouvrent sur la vitrine, dans un
 * nouvel onglet. Par défaut les CGU et la confidentialité ; le back-office y ajoute
 * les CGV pour l'admin, le seul qu'elles engagent.
 */
function LegalMenuItems({ pages = ['TERMS_OF_USE', 'PRIVACY'] }: { pages?: LegalPage[] }) {
  const { t, i18n } = useTranslation()

  return pages.map(page => (
    <DropdownMenuItem key={page} asChild className="cursor-pointer">
      <a href={legalUrl(page, i18n.language)} target="_blank" rel="noopener noreferrer">
        <FileText className="mr-2 size-4" aria-hidden />
        <span>{t(`legal.document.${page}`)}</span>
        <span className="sr-only">{t('legal.links.newTab')}</span>
      </a>
    </DropdownMenuItem>
  ))
}

export default LegalMenuItems
